import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DetailHeaderProps {
  backTo: string;
  backLabel?: string;
  title: string;
  badge?: ReactNode;
  actions?: ReactNode;
}

export function DetailHeader({
  backTo,
  backLabel,
  title,
  badge,
  actions,
}: DetailHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-4">
        <Link
          to={backTo}
          className="flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary transition-colors"
        >
          <ChevronLeft size={16} />
          {backLabel || t("common.back")}
        </Link>
        <h1 className="text-lg font-semibold text-text-primary">{title}</h1>
        {badge && <div className="flex items-center gap-2">{badge}</div>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
